module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iipC3"))).then(() => parcelRequire('hEqeo'));